(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["night-scrunchie-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-scrunchie-pack')) {
  class NightScrunchiePack extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.js-product');
      if (!this.productSection || this.variantListener) return;
      this.variantListener = (event) => this.showVariant(event.detail?.variant?.id);
      this.productSection.addEventListener('on:variant:change', this.variantListener);
      const picker = this.productSection.querySelector('variant-picker');
      const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
      this.showVariant(selected?.id || this.dataset.initialVariant);
    }
    showVariant(id) {
      this.querySelectorAll('[data-night-variant]').forEach((el) => {
        el.hidden = el.dataset.nightVariant !== String(id);
      });
    }
    disconnectedCallback() {
      this.productSection?.removeEventListener('on:variant:change', this.variantListener);
      this.variantListener = null;
    }
  }
  customElements.define('night-scrunchie-pack', NightScrunchiePack);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-silk-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-silk-purchase')) {
    customElements.define('night-silk-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.variantHandler) return;
        this.scope = this.closest('.section-main-product');
        this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.variantHandler = (event) => {
          if (!this.closest('.js-product').contains(event.target)) return;
          const variant = event.detail.variant;
          const details = variant && this.data.variants[variant.id];
          this.querySelector('.night-silk-status').textContent = details ? details.status : this.data.unavailable;
          this.querySelector('.night-silk-dispatch').hidden = !details || !details.dispatch;
          this.scope.querySelectorAll('.night-silk-sticky-price').forEach((price) => {
            price.textContent = details ? details.price.replace(/<[^>]*>/g, '') : '';
          });
        };
        this.scope.addEventListener('on:variant:change', this.variantHandler);
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('on:variant:change', this.variantHandler);
        this.variantHandler = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-skincare-variant-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-variant-content')) {
    class NightVariantContent extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.js-product');
        if (!this.productSection || this.variantListener) return;
        this.variantListener = (event) => {
          const variant = event.detail?.variant;
          this.showVariant(variant?.id);
          if (variant && this.dataset.mode === 'hero') {
            const gallery = this.closest('media-gallery');
            const packSlide = this.closest('.slider__item[data-media-id]');
            if (typeof gallery?.setActiveMedia === 'function') gallery.setActiveMedia(packSlide?.dataset.mediaId || 'night-1', true);
          }
        };
        this.productSection.addEventListener('on:variant:change', this.variantListener);
        const picker = this.productSection.querySelector('variant-picker');
        const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
        this.showVariant(selected?.id || this.dataset.initialVariant);
      }
      showVariant(variantId) {
        this.querySelectorAll('[data-night-variant]').forEach((element) => {
          element.hidden = element.dataset.nightVariant !== String(variantId);
        });
        if (this.dataset.mode === 'hero') {
          const imageLink = this.querySelector('[data-night-variant]:not([hidden]) .show-gallery');
          const zoomThumb = this.closest('media-gallery')?.galleryModal?.querySelector('[data-night-pack-zoom]');
          if (imageLink && zoomThumb) {
            zoomThumb.dataset.zoomUrl = imageLink.getAttribute('href');
            const thumbImage = zoomThumb.querySelector('img');
            thumbImage.src = imageLink.dataset.zoomThumbnail;
            thumbImage.removeAttribute('srcset');
            thumbImage.alt = imageLink.querySelector('img')?.alt || '';
          }
        }
      }
      disconnectedCallback() {
        this.productSection?.removeEventListener('on:variant:change', this.variantListener);
        this.variantListener = null;
      }
    }
    customElements.define('night-variant-content', NightVariantContent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-skinny-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-scrunchie-pack')) {
  class NightScrunchiePack extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.js-product');
      if (!this.productSection || this.variantListener) return;
      this.variantListener = (event) => this.showVariant(event.detail?.variant?.id);
      this.productSection.addEventListener('on:variant:change', this.variantListener);
      const picker = this.productSection.querySelector('variant-picker');
      const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
      this.showVariant(selected?.id || this.dataset.initialVariant);
    }
    showVariant(id) {
      this.querySelectorAll('[data-night-variant]').forEach((el) => {
        el.hidden = el.dataset.nightVariant !== String(id);
      });
    }
    disconnectedCallback() {
      this.productSection?.removeEventListener('on:variant:change', this.variantListener);
      this.variantListener = null;
    }
  }
  customElements.define('night-scrunchie-pack', NightScrunchiePack);
}
  } catch(e) { console.error(e); }
})();

})();
